// useEditCustomer.ts
import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { EditCustomerProps, CustomerFormData } from "../types";
import { updateCustomerApi, handleUpdateError } from "./api";
import { useFormHandlers } from "../utils/handlers";

export const useEditCustomer = (props: EditCustomerProps) => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState<CustomerFormData>({
    name: props.name || "",
    phoneNumber: props.phone || "",
    alternativePhone: props.alternativephone || "",
    email: props.email || "",
    address1: props.address || "",
    address2: props.address2 || "",
    address3: props.address3 || "",
  });

  const [isDuplicatePhone, setIsDuplicatePhone] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  /** sync props → state */
  useEffect(() => {
    setFormData({
      name: props.name || "",
      phoneNumber: props.phone || "",
      alternativePhone: props.alternativephone || "",
      email: props.email || "",
      address1: props.address || "",
      address2: props.address2 || "",
      address3: props.address3 || "",
    });
  }, [props]);

  /** handlers */
  const { handleNameChange, handlePhoneChange, handleAlternativePhoneChange, handleEmailChange, handleAddress1Change, handleAddress2Change, handlePincodeChange } = useFormHandlers(
    formData,
    setFormData,
    setIsDuplicatePhone
  );

  /** API */
  const updateCustomer = useCallback(async () => {
    if (loading) return;
    if (!formData.name.trim() || !formData.phoneNumber.trim()) {
      toast.error("Please fill in the required fields: Name and Phone Number.", {
        theme: "colored",
        autoClose: 2000,
      });
      return;
    }
     setLoading(true);
    try {
      await updateCustomerApi(props.id, formData, () => {
        props.closeEditcustomer();
        props.refreshCustomerList();
      });
    } catch (err) {
      setIsLoading(false); // Stop loading on error
      handleUpdateError(err as any);
    } finally {
      setLoading(false); // ✅ Stop loading regardless of success/error
    }
  }, [formData, props,loading]);

  const closeEditCustomer = useCallback(() => {
    if (!isLoading) {
      props.closeEditcustomer();
    }
  }, [isLoading, props]);

  return {
    formData,
    isDuplicatePhone,
    isLoading, // Return loading state
    handleNameChange,
    handlePhoneChange,
    handleAlternativePhoneChange,
    handleEmailChange,
    handleAddress1Change,
    handleAddress2Change,
    handlePincodeChange,
    updateCustomer,
    closeEditCustomer,
  };
};